import { formatInZone } from './util';

interface Props {
  sentAtUtc: string | null;
  sentBy: string | null;
  zone: string | null;
}

export function EmailSentNote({ sentAtUtc, sentBy, zone }: Props) {
  if (!sentAtUtc) {
    return null;
  }
  return (
    <span className="text-onlight-text-2 dark:text-ondark-text-2 text-xs">
      Email sent at {formatInZone(sentAtUtc, zone, 'MMM D, YYYY h:mm A')}
      {sentBy ? ` by ${sentBy}` : ''}
    </span>
  );
}

export default EmailSentNote;
